/**
 * @file: description
 * @author:
 * @Date: 2020-03-24 21:16:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 15:10:46
 */
/**
 * @description 全局Model artModel 挂载到 redux 上
 */
import { TkitUtils as Utils } from '@tkit/types';
import createModel, { Tction } from '@tkit/model';
import { APIS, AdminHotArticleVO, ClassifyInfo } from '@src/services';
import { message } from 'antd';

export interface State {
  admineArts: AdminHotArticleVO[];
  admineSearchLoading: boolean;
  adminArticlesTotal: number;
  artClassList: ClassifyInfo[];
  pageNum: number;
}

export const artModelState: State = {
  admineArts: [],
  admineSearchLoading: false,
  adminArticlesTotal: 0,
  artClassList: [],
  pageNum: 1
};

const model = createModel({
  state: artModelState,
  namespace: 'artModel',
  reducers: {
    // @params.0 state
    // @params.0 action
    setAdmineSearchArticles: (state, action: Tction<AdminHotArticleVO[]>) => {
      return {
        ...state,
        admineArts: action.payload
      };
    },
    setAdminArticlesTotal: (state, action: Tction<number>) => {
      return {
        ...state,
        adminArticlesTotal: action.payload
      };
    },
    setAdmineSearchLoading: (state, action: Tction<boolean>) => {
      return {
        ...state,
        admineSearchLoading: action.payload
      };
    },
    /**
     * @description 设置文章分类列表
     */
    setArtClassList: (state, action: Tction<ClassifyInfo[]>) => {
      return {
        ...state,
        artClassList: action.payload
      };
    },
    setPageNum: (state, action: Tction<number>) => {
      return {
        ...state,
        pageNum: action.payload
      };
    }
  },
  effects: {
    // @params.0 sagaEffect
    // @params.0 action
    *admineSearchArticlesAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{ title: string; authorUserName: string; pageNum: number; pageSize: number }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.setAdmineSearchLoading, true);
      const data: Utils.GetROA<typeof APIS.AdminApi.adminUsingGet> = yield tCall(
        APIS.AdminApi.adminUsingGet,
        action.payload
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setAdmineSearchArticles, data.result.list || []);
        yield tPut(model.actions.setAdminArticlesTotal, data.result.total || 0);
      }

      yield tPut(model.actions.setAdmineSearchLoading, false);
      yield tPut(model.actions.setPageNum, action.payload.pageNum);
    },
    /**
     * @deprecated 获取文章分类列表
     */
    *getClassListAsync({ namespace, put, tPut, tCall }): Iterator<{}, any, any> {
      const data: Utils.GetROA<typeof APIS.ClassifyApi.classifyBaseAllUsingGet> = yield tCall(
        APIS.ClassifyApi.classifyBaseAllUsingGet
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setArtClassList, data.result);
      }
    },
    /**
     * @deprecated 删除文章
     */
    *deleteArticle(
      { tPut, tCall },
      action: Tction<{ params: { articleId: number } }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.BannerApi.bannerDeleteTypeUsingDelete> = yield tCall(
        APIS.AdminApi.deleteArticle,
        params
      );
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.admineSearchArticlesAsync, {
          pageNum: model.state.pageNum,
          title: '',
          authorUserName: '',
          pageSize: 10
        });
      } else {
        message.error(res.message);
      }
    }
  }
});

export default model;
